import { Result } from '@findemdev/maui';
import React, { Component } from 'react';

const Forbidden: React.FC<
  React.ComponentProps<typeof Component>
> = () => (
  <Result
    status='403'
    title=""
    subTitle="Sorry, you don't have enough privilege to access this page."
  />
);

export default Forbidden;
